import React from 'react';
import './CSS/App.css';
import MDMApp from 'swfrontend/MDMApp'
import getRoutes from "./ScreenRouters";
import { localStorageVariableName } from "swfrontend/AppConfigs";
import LoginPage from "swfrontend/LOGIN/LoginPage";
import { BrowserRouter } from "react-router-dom"
import CommonLogin from './CommonLogin';
import VendorInputs from '../DailyProgressReport/VendorInputs/VendorInputs';
import CookieFooter from "../PrivacyPolicy/CookieFooter";


const App = () => {
    return (
        window.location.pathname.includes("VendorInputs") ?
            <VendorInputs />
        :
        localStorage.getItem(localStorageVariableName.authToken) == null ?
            <>
                <CookieFooter />
                <CommonLogin />
            </> :
            <BrowserRouter><MDMApp routes={getRoutes} /></BrowserRouter>
    )
};

export default App;
